var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x31_08-analytics_x2C__google_analytics_x2C__google"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M330.564,166.28H181.438c-8.232,0-14.912,6.699-14.912,14.956v299.06      c0,8.251,6.68,14.954,14.912,14.954h149.127c8.23,0,14.91-6.703,14.91-14.954v-299.06      C345.475,172.979,338.795,166.28,330.564,166.28L330.564,166.28z M330.564,166.28",
    style: {
      fill: "#FFC107"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.438,315.813H32.313c-8.236,0-14.916,6.698-14.916,14.953v149.53      c0,8.251,6.68,14.954,14.916,14.954h149.125c8.234,0,14.914-6.703,14.914-14.954v-149.53      C196.352,322.511,189.672,315.813,181.438,315.813L181.438,315.813z M181.438,315.813",
    style: {
      fill: "#FFC107"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.689,16.75H330.564c-8.236,0-14.916,6.698-14.916,14.958v448.588      c0,8.251,6.68,14.954,14.916,14.954h149.125c8.234,0,14.914-6.703,14.914-14.954V31.708      C494.604,23.448,487.924,16.75,479.689,16.75L479.689,16.75z M479.689,16.75",
    style: {
      fill: "#FFA000"
    }
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/googleIcon.abfa9a1266a11f6b678be0f340f42fe4.svg";
export { ForwardRef as ReactComponent };